import { createContext } from 'react';

export const CRMContext = createContext(null);
